"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
// import { URLShortner } from './URLShortner';
class Campaign extends Parse.Object {
    constructor(attributes) {
        super('Campaign', attributes);
    }
    get retailer() { return this.get('retailer'); }
    set retailer(value) { this.set('retailer', value); }
    get title() { return this.get('title'); }
    set title(value) { this.set('title', value); }
    get textMessage() { return this.get('textMessage'); }
    set textMessage(value) { this.set('textMessage', value); }
    get platform() { return this.get('platform'); }
    set platform(value) { this.set('platform', value); }
    get status() { return this.get('status'); }
    set status(value) { this.set('status', value); }
    get sentProgress() { return this.get('sentProgress'); }
    set sentProgress(value) { this.set('sentProgress', value); }
    get readProgress() { return this.get('readProgress'); }
    set readProgress(value) { this.set('readProgress', value); }
    get deliveredProgress() { return this.get('deliveredProgress'); }
    set deliveredProgress(value) { this.set('deliveredProgress', value); }
    get clickedProgress() { return this.get('clickedProgress'); }
    set clickedProgress(value) { this.set('clickedProgress', value); }
    get repliedProgress() { return this.get('repliedProgress'); }
    set repliedProgress(value) { this.set('repliedProgress', value); }
    get failedProgress() { return this.get('failedProgress'); }
    set failedProgress(value) { this.set('failedProgress', value); }
    get optOutProgress() { return this.get('optOutProgress'); }
    set optOutProgress(value) { this.set('optOutProgress', value); }
    get salesProgress() { return this.get('salesProgress'); }
    set salesProgress(value) { this.set('salesProgress', value); }
    get lastSentAt() { return this.get('lastSentAt'); }
    set lastSentAt(value) { this.set('lastSentAt', value); }
    get audienceType() { return this.get('audienceType'); }
    set audienceType(value) { this.set('audienceType', value); }
    get audienceCount() { return this.get('audienceCount'); }
    set audienceCount(value) { this.set('audienceCount', value); }
    get audienceFile() { return this.get('audienceFile'); }
    set audienceFile(value) { this.set('audienceFile', value); }
    get audienceFileTokenMapping() { return this.get('audienceFileTokenMapping'); }
    set audienceFileTokenMapping(value) { this.set('audienceFileTokenMapping', value); }
    get audienceCustomerFilters() { return this.get('audienceCustomerFilters'); }
    set audienceCustomerFilters(value) { this.set('audienceCustomerFilters', value); }
    get audienceCustomerList() {
        return this.get('audienceCustomerList');
    }
    set audienceCustomerList(value) {
        this.set('audienceCustomerList', value);
    }
    get scheduledTo() { return this.get('scheduledTo'); }
    set scheduledTo(value) { this.set('scheduledTo', value); }
    get rateLimit() { return this.get('rateLimit'); }
    set rateLimit(value) { this.set('rateLimit', value); }
    get trackingForSales() { return this.get('trackingForSales'); }
    set trackingForSales(value) { this.set('trackingForSales', value); }
    get routeReplies() { return this.get('routeReplies'); }
    set routeReplies(value) { this.set('routeReplies', value); }
    get smsCount() { return this.get('smsCount'); }
    set smsCount(value) { this.set('smsCount', value); }
}
exports.Campaign = Campaign;
Parse.Object.registerSubclass('Campaign', Campaign);
//# sourceMappingURL=Campaign.js.map